import * as React from 'react';
import Box from '@mui/material/Box';
import { columns, generateRows } from './partials';
import { Table } from '@organisms';
import { callGetCoreUsers } from '@api';
import { useState, useContext } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { TableContext } from '@particles';
import { Alert } from '@atoms';

const CoreUsers: React.FC<{ locationId: string }> = ({ locationId }) => {
  const {
    state: {
      coreUsersPagination: { page, perPage, orderBy }
    }
  } = useContext(TableContext);

  const [error] = useState<string>();

  const usersQuery = useQuery({
    queryKey: ['core-users', locationId, page, perPage, orderBy],
    queryFn: () => callGetCoreUsers({ locationId, pageNumber: page, pageSize: perPage, sortBy: orderBy }),
    placeholderData: keepPreviousData
  });

  const data: Pagination<CoreUser> | undefined =
    usersQuery.data?.code === 200 ? usersQuery.data.data : undefined;
  const loading = usersQuery.isFetching;
  const rowData: TableRow[] = data ? generateRows(data.data) : [];

  return (
    <Box>
      {error && (
        <Box sx={{ mb: 1 }}>
          <Alert message={error} severity={'error'} />
        </Box>
      )}

      <Table
        name="core_users"
        columns={columns}
        data={rowData}
        isLoading={loading}
        pagination={data}
        persistColumnPrefs
      />
    </Box>
  );
};

export default CoreUsers;
